import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TabContent, TabPane } from 'reactstrap';

import { fetchAcceptedTermsOfService } from '../../../actions/UploadPages';

import { APIfetchAcceptedTermsOfService } from '../../../api/UploadPages';

import AdminUploadPageUploads from './Uploads';
import TermsOfService from '../TermsOfService/TermsOfService';

const UploadPageDetailsTabContent = ({ activeTab, uploadPage }) => {
  const intl = useIntl();

  return (
    <TabContent activeTab={activeTab} className="settings-tab-content">
      <TabPane tabId="collected-details">
        <div className="tab-content-wrapper">
          <AdminUploadPageUploads uploadPage={uploadPage} />
        </div>
      </TabPane>
      <TabPane tabId="tos">
        <TermsOfService
          entityUuid={uploadPage.uuid}
          subtitle={intl.formatMessage({ defaultMessage: 'Browse accepted terms of service on this guest upload page' })}
          fetchAcceptedTermsOfService={fetchAcceptedTermsOfService}
          APIfetchAcceptedTermsOfService={APIfetchAcceptedTermsOfService}
        />
      </TabPane>
    </TabContent>
  );
};

UploadPageDetailsTabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  uploadPage: PropTypes.object.isRequired,
};

export default UploadPageDetailsTabContent;
